/* Created by Interactive 63 - https://interactive63.com */
/**
 * The keyboard shortcuts the editor responds to, grouped for the shortcut sheet. Keys are listed
 * as they appear on a Windows keyboard.
 */

export interface Shortcut {
  keys: string;
  action: string;
}

export interface ShortcutGroup {
  title: string;
  shortcuts: Shortcut[];
}

export const SHORTCUT_GROUPS: ShortcutGroup[] = [
  {
    title: 'Help',
    shortcuts: [{ keys: 'H or ?', action: 'Show this sheet' }],
  },
  {
    title: 'Playback',
    shortcuts: [
      { keys: 'Space', action: 'Play or pause' },
      { keys: 'Home / End', action: 'Move the playhead to the start or end' },
      { keys: '← / →', action: 'Move the playhead one frame' },
      { keys: 'Shift + ← / →', action: 'Move the playhead 100 ms' },
    ],
  },
  {
    title: 'Keyframes',
    shortcuts: [
      { keys: 'Q / E', action: 'Jump to the previous or next keyframe on the selected element' },
      { keys: 'W', action: 'Key every animated property of the selection at the playhead' },
      { keys: 'Delete / Backspace', action: 'Delete the selected keyframes' },
      { keys: 'Delete', action: 'Delete the selected layers when no keyframes are selected' },
      { keys: 'Ctrl + C / Ctrl + V', action: 'Copy keyframes, paste them at the playhead' },
      { keys: 'Ctrl + D', action: 'Duplicate the selected keyframes at the playhead' },
      { keys: 'Ctrl + D', action: 'Duplicate the selected layers when no keyframes are selected' },
      { keys: 'Ctrl + A', action: 'Select all keyframes on the selected elements' },
    ],
  },
  {
    title: 'Layers',
    shortcuts: [
      { keys: 'T', action: 'Add a text layer and type its words' },
      { keys: 'Ctrl + G', action: 'Group the selected layers' },
      { keys: 'Ctrl + Shift + G', action: 'Ungroup the selected groups' },
      { keys: 'Alt + Up / Down', action: 'Move the selected layers up or down the Layers list' },
      { keys: 'Alt + Left', action: 'Move the selected layers out of their group' },
    ],
  },
  {
    title: 'Stage',
    shortcuts: [
      { keys: '1 / 2 / 3', action: 'Select, rotate and scale tools' },
      {
        keys: 'Arrow keys',
        action: 'Nudge the selection by 1 unit (Shift for 10) while the stage has focus',
      },
      { keys: 'Hold 4', action: 'Show the pivot rulers' },
      { keys: '4 + arrow keys', action: 'Nudge the pivot by 1 unit (Shift for 10, Alt for 0.1)' },
      { keys: 'Ctrl + 0', action: 'Fit the artwork to the stage' },
      { keys: 'Ctrl + mouse wheel', action: 'Zoom the stage, or the timeline when hovering it' },
      { keys: 'Escape', action: 'Clear the selection, close a dialog or cancel picking a shape' },
    ],
  },
  {
    title: 'Project',
    shortcuts: [
      { keys: 'Ctrl + Z', action: 'Undo' },
      { keys: 'Ctrl + Shift + Z / Ctrl + Y', action: 'Redo' },
      { keys: 'Ctrl + S', action: 'Save the project file' },
      { keys: 'Ctrl + Shift + S', action: 'Save as a new project and file' },
      { keys: 'Ctrl + O', action: 'Open a project file' },
      { keys: 'Ctrl + E', action: 'Open the export dialog' },
    ],
  },
];
